import React, { useEffect, useMemo, useState } from "react";

import { noTransaction } from "../../assets/images";
import { UserActivityAddressesTable } from "./userActivityAddressesTable";
import {
  filterWalletsBySegment,
  segmentCounts,
  type UserWalletRecord,
  type WalletSegment,
} from "./userActivityWalletUtils";

const SEGMENTS: { id: WalletSegment; label: string }[] = [
  { id: "otc", label: "OTC" },
  { id: "sell", label: "Sell" },
  { id: "deposit", label: "Deposit" },
];

type AddressesProps = {
  wallets: UserWalletRecord[];
  isLoading?: boolean;
};

const Addresses = ({
  wallets,
  isLoading = false,
}: AddressesProps) => {
  const counts = useMemo(() => segmentCounts(wallets), [wallets]);
  const [segment, setSegment] = useState<WalletSegment>("sell");

  useEffect(() => {
    if (counts[segment] > 0) return;
    const firstWithData = SEGMENTS.find((s) => counts[s.id] > 0);
    if (firstWithData) setSegment(firstWithData.id);
  }, [counts, segment]);

  const filteredWallets = useMemo(
    () => filterWalletsBySegment(wallets, segment),
    [wallets, segment]
  );

  return (
    <div className="w-full px-1 pb-8 pt-2">
      <div className="mb-2 flex flex-wrap items-center gap-2 sm:gap-3">
        {SEGMENTS.map(({ id, label }) => {
          const active = segment === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => setSegment(id)}
              className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-[13px] font-semibold transition-all ${
                active
                  ? "border-secondary_button bg-secondary_button/10 text-secondary_button shadow-[0_0_0_1px_rgba(12,132,218,0.15)]"
                  : "border-[#2C363E] bg-[#13181B] text-[#869AA9] hover:border-[#3A4852] hover:text-[#C6D0D7]"
              }`}
            >
              {label}
              <span
                className={`rounded-full px-2 py-0.5 text-[11px] ${
                  active
                    ? "bg-secondary_button/20 text-secondary_button"
                    : "bg-[#1C2227] text-[#617889]"
                }`}
              >
                {counts[id]}
              </span>
            </button>
          );
        })}
      </div>

      <UserActivityAddressesTable
        wallets={filteredWallets}
        segment={segment}
        isLoading={isLoading}
        emptyImage={noTransaction}
      />
    </div>
  );
};

export default Addresses;
